import React from "react";
import { FaCheck } from "react-icons/fa";

export default function ProjectCard({ title, image, description, keyPhrases }) {
  return (
    <div className="p-4 sm:p-6 md:p-8 xl:border-t bg-white rounded-lg shadow-lg hover:shadow-xl transition duration-300 flex flex-col h-full">
      <div className="flex items-start mb-4 sm:mb-6 min-h-[80px] sm:min-h-[90px] md:min-h-[100px] lg:min-h-[110px] xl:min-h-[120px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 text-purple-500 mr-2 sm:mr-3 flex-shrink-0 mt-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 7l6 6-6 6"
          />
        </svg>
        <h3 className="text-xl sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-semibold text-gray-900 leading-tight">
          {title}
        </h3>
      </div>
      
      <div className="h-0.5 w-auto mx-2 sm:mx-4 md:mx-6 lg:mx-8 xl:mx-12 border-b-4 mb-4 sm:mb-6 border-gray-300" />
      
      <div className="flex-grow flex flex-col">
        <img
          src={image}
          alt={title}
          className="mb-4 sm:mb-6 w-full h-48 sm:h-56 md:h-64 object-contain rounded-lg"
        />
        
        {/* Brève phrase de description */}
        <p className="text-gray-700 text-base sm:text-lg md:text-xl mb-4 sm:mb-6 font-semibold leading-relaxed">
          {description}
        </p>
        
        {/* Liste des phrases clés avec icône */}
        <ul className="space-y-2 sm:space-y-3 flex-grow">
          {keyPhrases.map((phrase, index) => (
            <li key={index} className="flex items-start">
              <FaCheck className="text-purple-500 mr-2 sm:mr-3 flex-shrink-0 mt-1" size={16} />
              <span className="text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                {phrase}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
